import type { SiteContext } from '@smarton-pbx/shared';
import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router';
import { api } from './api';
import { Notice } from './components/ui';
import { t } from './i18n';
import { applyBranding } from './lib/branding';
import { PlatformApp } from './platform/PlatformApp';
import { TenantApp } from './tenant/TenantApp';

/**
 * One web app for every site. The hostname decides whether this is a
 * tenant's site (with that tenant's branding) or the platform console.
 */
export function App() {
  const [context, setContext] = useState<SiteContext>();
  const [error, setError] = useState<string>();

  const load = useCallback(() => {
    api.context().then(
      (result) => {
        applyBranding(result);
        setContext(result);
      },
      () => setError(t('This site is not available.')),
    );
  }, []);

  useEffect(load, [load]);

  if (error) {
    return (
      <div className="centered">
        <Notice kind="error">{error}</Notice>
      </div>
    );
  }
  if (!context) return null;

  return (
    <BrowserRouter>{context.kind === 'platform' ? <PlatformApp context={context} /> : <TenantApp context={context} onBrandingChanged={load} />}</BrowserRouter>
  );
}
